
// Converted to Tailwind classes; removed MUI Typography
import { Link } from "react-router-dom";
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import { IconButton } from "@mui/material";



type cardServicesProps = {
    nomeOpcao: string;
    link: string;
    url?: string;
}
export default function ListaOpcoes({ nomeOpcao, link, url }: cardServicesProps) {

    return (
        <CardActionArea className="tw-h-[70px] tw-w-full tw-bg-[#85287e] tw-rounded-[5px] tw-transition-all tw-duration-300 tw-overflow-auto tw-flex tw-justify-start tw-mt-4 hover:tw-shadow-lg">
            {url &&
                <IconButton className="hover:tw-shadow-lg hover:tw-border-white" onClick={() => window.open(url ?? link, "_blank", "noopener,noreferrer")}>
                    <img src='/img/icones/downloadicon.svg' alt="downloadicon" />
                </IconButton>
            }

            <Link className="tw-no-underline tw-w-full" to={link}>
                <CardContent className="tw-p-1">
                    <p className="tw-leading-tight tw-text-sm tw-text-white tw-pl-5">{nomeOpcao}</p>
                </CardContent>
            </Link>
        </CardActionArea>
    )
}